import React, {Component} from 'react';
import * as firebase from 'firebase';
import MetaTags from 'react-meta-tags';
import ReactLoading from 'react-loading';
import {Link} from 'react-router-dom';
import photo from '../images/亞健康-350.gif'

export default class MedicalTeams extends Component {
    constructor() {
        super();
        this.state = {
            croppedImg: '',
            selfIntroduction: '',
            FBGroup: '',
            webSite: '',
            loading: true,
            imgLoad: false,
            listOfPositions: []
        }
        this.handleImageOnLoad = this.handleImageOnLoad.bind(this);
    }
    handleImageOnLoad() {
        this.setState({
          imgLoad: true
        })
      }
    componentDidMount() {
        window.scrollTo(0,0);
        var img = new window.Image();
        img.onload = this.handleImageOnLoad;
        setTimeout(() => this.setState({ loading: false }), 1500);
        let getUserId = this.props.match.params.userId;
        const getMedicalTeamRef = firebase.database().ref('medicalTeam/').orderByChild('userId').equalTo(getUserId)
        getMedicalTeamRef.on('value', snap => {
            snap.forEach((child) => {
              this.setState({
                userId: child.val().userId,
                croppedImg: child.val().croppedImg,
                name: child.val().name,
                selfIntroduction: child.val().selfIntroduction,
                FBGroup: child.val().FBGroup,
                webSite: child.val().webSite
              })
                
            })
        })
  
        const allPostListRef = firebase.database().ref('MedicalTeamPosts/').orderByChild('userId').equalTo(getUserId);
        allPostListRef.on('value', snap => {
          snap.forEach((child) => {
            const previousList = this.state.listOfPositions;
            previousList.push({
              createDate: child.val().createDate,
              createTime: child.val().createTime,
              blogName: child.val().blogName,
              blogTag: child.val().blogTag,
              secondTag: child.val().secondTag,
              otherTag1: child.val().otherTag1,
              otherTag2: child.val().otherTag2,
              croppedImg: child.val().croppedImg ? child.val().croppedImg : 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/Authority%2Fee05d537-ddf4-47a2-b1a2-21a6063a4299.gif?alt=media&token=824bf77c-bbae-408e-af80-7e4b8d5d1ea7',
              id: child.val().id,
              author: child.val().author,
              authorUrl: child.val().authorUrl,
              name: child.val().name,
              Authority: child.val().Authority,
              theAuthor: 'MedicalTeams/' + child.val().name,
              description: child.val().description
            })
            this.setState({
                listOfPositions: previousList.reverse()
            })
          })
        })

    }
    render() {
        const { loading } = this.state;
        if(loading) {
          return <ReactLoading type={"bubbles"} color={"#333"} style={Jeyu.loading} />
        }
        var { className } = this.props;
        var checkImg = className ? className + ' image' : 'image';
        if (this.state.imgLoad) {
          checkImg += ' image-loaded';
        }

        const listOfPositions = this.state.listOfPositions.map(position =>
            <article key={position.id} className="MedicalListPost">
                <div className="left">
                 <Link to={"/AuthorityBlogs/" + position.id} target="_blank">
                  <img
                   className={checkImg}
                   onLoad={this.handleImageOnLoad}
                   src={position.croppedImg}
                   alt={position.blogTag} 
                   title={position.blogName} 
                   />
                  </Link>
                </div>
                <div className="right">
                 <Link to={"/AuthorityBlogs/" + position.id} target="_blank">
                  <h1 style={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden', width: '90%' }}>{ position.blogName }</h1>
                  <p style={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden', width: '90%' }}>{position.description}</p>
                 </Link>
                 <sub className="postListTagsBox">
                  <Link to={"/AuthorityTag/" + position.blogTag} target="_blank">{ position.blogTag }</Link>
                  <Link to={"/AuthorityTags/" + position.secondTag} target="_blank">{ position.secondTag }</Link>
                  <Link to={"/AuthorityTagsa/" + position.otherTag1} style={{display: position.otherTag1 ? 'inline-block' : 'none'}} target="_blank">{ position.otherTag1 }</Link>
                  <Link to={"/AuthorityTagsb/" + position.otherTag2} style={{display: position.otherTag2 ? 'inline-block' : 'none'}} target="_blank">{ position.otherTag2 }</Link>
                 </sub><br />
                 <sub style={{padding: '0 0 0 7px'}}>
                  <span>{position.createDate}</span> <span>{position.createTime}</span>
                  <a href={position.authorUrl} target="_blank" rel="noopener noreferrer" className="author" style={{display: position.author ? 'inline-block' : 'none', marginLeft: 10}} >引用自: {position.author}</a>
                 </sub>
                </div>
          </article>
         )
        return(
            <div className="container-fluid">
             <div className="row haspcMinH2">
              <MetaTags>
               <title>草學藥事 || 健康達人專欄</title>
               <meta id="og-title" property="og:title" content="健康達人專欄" />
              </MetaTags>
              <div className="MedicalTeamBanner">
                <h1 style={{color: '#fff'}} >健康達人專欄</h1>
              </div>
              <div className="container">
                  <div className="row" style={{marginTop: 30, marginBottom: 30}} >
                      <div className="col-xs-12 col-sm-12 col-md-9 col-lg-9">
                          <div className="MedicalListPostBox">
                              <div style={{display: this.state.imgLoad ? 'none' : 'flex', justifyContent: 'center', alignItems: 'center'}} >
                                  <span> <img src={photo} alt="草學藥事" style={{height: 150}} /> </span><span>資料庫比對中....暫時沒獲取任何文章喔</span>
                              </div>
                           {listOfPositions}
                          </div>
                      </div>
                      <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                          <div className="AuthorityBox">
                                <div style={{textAlign: 'center', overflow: 'hidden'}} >
                                  <img src={this.state.croppedImg} alt={this.state.name ? '大頭照' : this.state.name}  style={{ width: '60%', borderRadius: '50%', display: 'block', margin: '0 auto', textAlign: 'center'}} />
                                </div>
                               <h1>{this.state.name} {this.state.Authority} </h1>
                               <a href={this.state.FBGroup} target='_blank' className="theFb" style={{ display: this.state.FBGroup ? 'inline-block' : 'none' }} >粉絲團</a>
                               <a href={this.state.webSite} target='_blank' className="theWebsite" style={{ display: this.state.webSite ? 'inline-block' : 'none' }} >個人網站</a>
                               <h3>自我介紹:</h3>
                               <article dangerouslySetInnerHTML={{__html: this.state.selfIntroduction}}></article>
                          </div>
                      </div>
                  </div>
              </div>
             </div>
            </div>
        )
    }
}
const Jeyu = {
    loading: {
      margin: '20% auto',
      width: 77,
      height: '100vh'
    }
  }


// WEBPACK FOOTER //
// ./src/post/MedicalTeams.js